module.exports = __webpack_public_path__ + "static/media/stage.0332cebf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/stage.jpg
// module id = 335
// module chunks = 0